// ==============================|| OVERRIDES - RADIO ||============================== //

export default function Radio(theme) {
	return {
		MuiRadio: {
			styleOverrides: {
				root: {
					"&.Mui-checked": {
						color: "#43BD98!important",
					},
				},
			},
		},
	};
}
